<div
  class="revision-filter-container"
  [ngClass]="[disabled ? 'revision-filter--disable' : '']"
>
  <label class="revision-filter-label">Revision History</label>
  <div
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomLeft"
    nzOverlayClassName="revision-filter-content-overlay"
    [(nzPopoverVisible)]="revFilterVisible"
    (nzPopoverVisible)="popoverChange()"
    class="revision-filter-select-container"
  >
    <p class="revision-filter-placeholder" *ngIf="!displaySelectedVal">
      {{ placeholder }}
    </p>
    <p
      class="revision-filter-selected-value"
      *ngIf="displaySelectedVal"
      [title]="displaySelectedVal"
      [innerHTML]="displaySelectedVal"
    ></p>
    <div class="revision-filter-select-icon-wrapper">
      <i
        nz-icon
        [nzType]="revFilterVisible ? 'up' : 'down'"
        class="angle-icon"
      ></i>
    </div>
    <ng-template #contentTemplate>
      <div class="revision-period-container">
        <div
          *ngFor="let revision of revisionPeriodList"
          (click)="onRevisionChange(revision.value)"
          class="revision-filter-list-item"
        >
          <span>{{ revision.label }}</span>
        </div>
        <div class="revision-filter-date-picker-container">
          <nz-date-picker
            [(ngModel)]="customDate"
            (ngModelChange)="onDateChange()"
            [nzDisabledDate]="disabledCustomDate"
            nzPlaceHolder="Custom Days"
            [ngStyle]="{
              'border-bottom': inValidCustomDate
                ? '1px solid red'
                : '1px solid #979797'
            }"
            class="revision-filter-calender"
          ></nz-date-picker
          ><i
            nz-icon
            nzType="exclamation-circle"
            nzTheme="outline"
            style="color: red"
            *ngIf="inValidCustomDate"
          ></i>
        </div>
      </div>
    </ng-template>
  </div>
</div>
